import { LoadingButton } from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  Paper,
  SvgIcon,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import {
  colorDisableGrey,
  colorLinkGrey,
  colorPrimary,
  colorSecondary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import CustomTabLabel from '../../custom/CustomTabLabel';
import {
  createTitle,
  getOptionLabel,
  handleError,
  isArrayNotEmpty
} from '../../utils/utils';
import { useSelector } from 'react-redux';
import { Close, CloseOutlined } from '@mui/icons-material';
import { UploadIcon } from '../../utils/iconSvg';
import { useDispatch } from 'react-redux';
import {
  addNewContent,
  deleteQuestions,
  getContentById,
  getContentList,
  getSectionList,
  getTagList,
  publishContent,
  revertAllAddContentData,
  revertPublishContent,
  revertSaveFlashCard,
  updateContent,
  updateContentResponses,
  updateContentSettings
} from '../../redux/reducers/contentSlice';
import {
  getNoAuthGradeList,
  getThemeList,
  getMediumList,
  getUnitsByGrade
} from '../../redux/reducers/mastersSlice';
import AddNewTagModal from './components/AddNewTagModal';
import AddNewSectionModal from './components/AddNewSectionModal';
import AddNewQuestions from './components/AddNewQuestions';
import ConfirmBox from '../../components/ConfirmBox';
import CustomPagination from '../../components/CustomTablePagination';
import SnackBarBox from '../../components/SnackBarBox';
import { FLASHCARD_ICON } from '../../utils/imageUrls';
import CustomAccordion from './components/CustomAccordion';
import { IOSSwitch } from '../../utils/styledLayout';
import {
  ALLOWED_CONTENT_TYPE_OPTIONS,
  isCoreContentType,
  mapContentTypeToApi,
  mapContentTypeToFormOption,
  normalizeContentPublishStatus
} from '../../utils/navigationMenu';

const RESPONSE_INTERACTION_FIELDS = {
  1: 'likes',
  2: 'comments',
  3: 'share',
  4: 'download'
};

const AddNewFlashCard = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    sectionList,
    tagList,
    isAddNewContentSuccess,
    isAddNewContentFailed,
    isAddNewContentLoading,
    addContentResponse,
    addNewContentErrorContainer,
    contentDetails,
    isUpadteContentResponsesSuccess,
    isUpadteContentResponsesLoading,
    updateContentSettingsResponse,
    isUpadteContentSettingsSuccess,
    isUpadteContentSettingsLoading,
    isUpadteContentLoading,
    isUpadteContentSuccess,
    isUpadteContentFailed,
    updateContent: updateContentResponse,
    upadteContentErrorContainer,
    isAddNewTagLoading,
    isAddNewTagSuccess,
    isAddNewTagFailed,
    addNewTagErrorContainer,
    addTagResponse,
    isAddNewSectionLoading,
    isAddNewSectionSuccess,
    isAddNewSectionFailed,
    addNewSectionErrorContainer,
    addSectionResponse,
    isPublishContentLoading,
    isPublishContentSuccess,
    isPublishContentFailed,
    publishContentResponse,
    publishContentErrorContainer,
    isSaveFlashCardLoading,
    isSaveFlashCardSuccess,
    isSaveFlashCardFailed,
    flashCardResponse,
    flashCardErrorContainer,
    isDeleteQuestionLoading,
    isDeleteQuestionSuccess,
    isDeleteQuestionFailed,
    deleteQuestionErrorContainer
  } = useSelector(state => state.content);
  const { noAuthGradeList, themeList, mediumList, unitList } = useSelector(
    state => state.masters
  );
  const { authData } = useSelector(state => state.auth);
  const [initialValues, setInitalValues] = useState({
    tabValue: location?.state?.tabValue || 0,
    page: 0,
    size: 10,
    searchFilter: ''
  });
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [progress, setProgress] = useState(0);
  const [contentId, setContentId] = useState(0);
  const [isHover, setIshover] = useState(false);
  const [isNewTagModalOpen, setIsNewTagModalOpen] = useState(false);
  const [isNewSectionModalOpen, setIsNewSectionModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [showError, setShowError] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState('');
  const [contentStatus, setContentStatus] = useState('');
  const [encryptedId, setEncryptedId] = useState('');
  const [gamificationData, setGamificationData] = useState({});
  const [isNewQuestionModalOpen, setIsNewQuestionModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [questionList, setQuestionList] = useState([]);
  const [editQuestionData, setEditQuestionData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const userId = authData?.userId || 0;

  const matchId = (id1, id2) => {
    return id1 === id2 || id1 === Number(id2) || String(id1) === String(id2);
  };

  const getEffectiveContentId = () =>
    contentId ||
    contentDetails?.contentId ||
    Number(localStorage.getItem('localContentId')) ||
    0;

  const resolveContentIdFromResponse = response =>
    response?.payload?.id ??
    response?.payload?.contentId ??
    response?.id ??
    response?.contentId ??
    null;

  const resolveEncryptedIdFromResponse = response =>
    response?.payload?.encryptedContentId ??
    response?.payload?.encrypted_content_id ??
    response?.encryptedContentId ??
    response?.encrypted_content_id ??
    null;

  const resolveEncryptedIdFromDetails = details =>
    details?.encryptedContentId ?? details?.encrypted_content_id ?? '';

  const getEffectiveContentStatus = () =>
    contentStatus || contentDetails?.status || 'Saved';

  const refreshContentDetails = () => {
    const encryptId =
      location.state?.encryptedContentId ||
      encryptedId ||
      resolveEncryptedIdFromDetails(contentDetails);
    if (encryptId) {
      dispatch(getContentById({ encryptId, userId }));
    }
  };

  const isThemeRequiredForContentType = contentTypeId =>
    contentTypeId && contentTypeId !== 'State';

  const isUnitRequiredForContentType = contentTypeId =>
    contentTypeId && contentTypeId !== 'Core';

  const resolveUnitId = unit => unit?.id ?? unit?.unitId ?? null;

  useEffect(() => {
    dispatch(revertPublishContent());
  }, []);

  // For Edit Page

  useEffect(() => {
    if (
      location.pathname === '/content-management/edit-flashcard' &&
      location.state
    ) {
      let encryptId = location.state?.encryptedContentId;
      setEncryptedId(encryptId);
      dispatch(getContentById({ encryptId, userId }));
      setContentId(location.state?.contentId || contentDetails?.contentId);
      localStorage.setItem('localContentId', location.state?.contentId);
    }
  }, [isUpadteContentSuccess, isUpadteContentResponsesSuccess]);

  useEffect(() => {
    if (!isUpadteContentLoading && isUpadteContentSuccess) {
      const updatedContentId = resolveContentIdFromResponse(
        updateContentResponse
      );
      const updatedEncryptId = resolveEncryptedIdFromResponse(
        updateContentResponse
      );

      if (updatedContentId) {
        setContentId(updatedContentId);
        localStorage.setItem('localContentId', updatedContentId);
      }
      if (updatedEncryptId) {
        setEncryptedId(updatedEncryptId);
      }
      setContentStatus('Saved');
      const encryptIdToRefresh =
        updatedEncryptId ||
        encryptedId ||
        resolveEncryptedIdFromDetails(contentDetails);
      if (encryptIdToRefresh) {
        dispatch(getContentById({ encryptId: encryptIdToRefresh, userId }));
      }

      setInitalValues(prev =>
        prev.tabValue === 0 ? { ...prev, tabValue: 1 } : prev
      );
    }
  }, [isUpadteContentLoading, isUpadteContentSuccess]);

  // Call Get API After FlashCard (Overview) is Created

  useEffect(() => {
    if (
      isAddNewContentSuccess &&
      addContentResponse &&
      initialValues.tabValue === 0
    ) {
      const newContentId = resolveContentIdFromResponse(addContentResponse);
      const newEncryptId = resolveEncryptedIdFromResponse(addContentResponse);

      if (newEncryptId) {
        setEncryptedId(newEncryptId);
        dispatch(getContentById({ encryptId: newEncryptId, userId }));
      }
      if (newContentId) {
        setContentId(newContentId);
        localStorage.setItem('localContentId', newContentId);
      }
      setContentStatus('Saved');
      setInitalValues(prev => ({ ...prev, tabValue: 1 }));
    }
  }, [isAddNewContentSuccess]);

  useEffect(() => {
    if (isUpadteContentResponsesSuccess && !isUpadteContentResponsesLoading) {
      const encryptIdToRefresh =
        encryptedId || resolveEncryptedIdFromDetails(contentDetails);
      if (encryptIdToRefresh) {
        dispatch(getContentById({ encryptId: encryptIdToRefresh, userId }));
      }
      setInitalValues(prev =>
        prev.tabValue === 2 ? { ...prev, tabValue: 3 } : prev
      );
    }
  }, [isUpadteContentResponsesSuccess, isUpadteContentResponsesLoading]);

  // Validation schema function
  const getValidationSchema = () => {
    // Only apply validation schema for tab 0 (Overview)
    if (initialValues?.tabValue === 0) {
      // For edit mode, make theme and medium optional if content doesn't have these values
      const isEditMode =
        location.pathname === '/content-management/edit-flashcard';
      const hasThemeData = contentDetails?.theme;
      const hasMediumData = contentDetails?.medium;

      return Yup.object().shape({
        contentTitle: Yup.string().required('Title is required'),
        grade: Yup.object().nullable().required('Please select grade'), // Always required now
        tags: Yup.array().nullable(),
        section: Yup.object().nullable().required('Please select section'),
        contentType: Yup.object()
          .nullable()
          .required('Please select Content type'),
        contentVisibility: Yup.object()
          .nullable()
          .required('Please select Content visibility'),
        // Theme validation will be handled in validate function
        theme:
          isEditMode && !hasThemeData
            ? Yup.object().nullable()
            : Yup.object().nullable(),
        // Medium validation
        medium:
          isEditMode && !hasMediumData
            ? Yup.object().nullable()
            : Yup.object().nullable().required('Please select medium'),
        // Unit is required for State, hidden for Core
        unit: Yup.mixed().nullable()
      });
    }
    // For tab 1, return empty schema (no validation)
    return Yup.object().shape({});
  };

  // Custom validation function for dynamic requirements
  const validateForm = values => {
    const errors = {};

    if (initialValues?.tabValue === 0) {
      const contentType = values?.contentType?.id;

      // Grade is always required now
      if (!values.grade) {
        errors.grade = 'Please select grade';
      }

      // Theme is required for Core, disabled for State
      if (isThemeRequiredForContentType(contentType) && !values.theme) {
        errors.theme = 'Please select theme';
      }

      if (
        isUnitRequiredForContentType(contentType) &&
        !resolveUnitId(values.unit)
      ) {
        errors.unit = 'Please select unit';
      }
    }

    return errors;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      contentTitle: '',
      contentDescription: '',
      grade: null,
      tags: [],
      section: null,
      contentType: null,
      contentVisibility: null,
      theme: null,
      medium: null,
      unit: null,
      likes: false,
      comments: false,
      share: false,
      download: false,
      allowPoints: false,
      pointsPerLike: 0,
      pointsPerComment: 0,
      pointsPerDownload: 0,
      pointsPerShare: 0,
      notifyAllRelevantUserByGrade: false,
      notifyAllStudents: false,
      notifyAllTeachers: false,
      notifyAllUserInSystem: false
    },
    validationSchema: getValidationSchema(),
    validate: validateForm,
    onSubmit: values => {
      if (initialValues?.tabValue === 0) {
        const addPayload = {
          uploadType: 'Flashcard' || '',
          title: values?.contentTitle,
          description: values?.contentDescription,
          duration: '',
          sectionId: values?.section?.id,
          contentType: mapContentTypeToApi(values?.contentType?.label),
          contentVisibility: values?.contentVisibility?.label,
          grade: values?.grade?.id,
          tagNames: isArrayNotEmpty(values?.tags)
            ? values.tags.map(tag => tag.label)
            : [],
          themeId: values?.theme?.id || null,
          mediumId: values?.medium?.id || null,
          unitId: isCoreContentType(values?.contentType?.id)
            ? null
            : resolveUnitId(values?.unit),
          status: 'Saved',
          loggedInUserName: authData?.userName || ''
        };

        const effectiveContentId = getEffectiveContentId();

        const editPayload = {
          contentId: effectiveContentId,
          uploadType: 'Flashcard' || '',
          title: values?.contentTitle,
          description: values?.contentDescription,
          duration: '',
          sectionId: values?.section?.id,
          contentType: mapContentTypeToApi(values?.contentType?.label),
          contentVisibility: values?.contentVisibility?.label,
          grade: values?.grade?.id,
          tagNames: isArrayNotEmpty(values?.tags)
            ? values.tags.map(tag => tag.label)
            : [],
          themeId: values?.theme?.id || null,
          mediumId: values?.medium?.id || null,
          unitId: isCoreContentType(values?.contentType?.id)
            ? null
            : resolveUnitId(values?.unit),
          status: 'Saved',
          loggedInUserName: authData?.userName || ''
        };

        const formData = new FormData();
        formData.append('file', null);
        formData.append('thumbnail', file);

        if (
          location.pathname === '/content-management/edit-flashcard' ||
          effectiveContentId
        ) {
          formData.append('content', JSON.stringify(editPayload));
          dispatch(updateContent({ formData, contentId: effectiveContentId }));
        } else {
          formData.append('content', JSON.stringify(addPayload));
          dispatch(addNewContent(formData));
        }
      } else if (initialValues?.tabValue === 1) {
        setInitalValues(prev => ({ ...prev, tabValue: 2 }));
      } else if (initialValues?.tabValue === 2) {
        dispatch(
          updateContentResponses({
            payload: {
              likes: values?.likes,
              likesContentType: 'All',
              comments: values?.comments,
              commentsContentType: 'All',
              share: values?.share,
              shareContentType: 'All',
              download: values?.download,
              downloadContentType: 'All',
              loggedInUserName: authData?.userName
            },
            contentId: getEffectiveContentId()
          })
        );
      } else if (initialValues?.tabValue === 3) {
        dispatch(
          updateContentSettings({
            payload: {
              allowPoints: values?.allowPoints,
              likesPoints: values?.pointsPerLike,
              sharePoints: values?.pointsPerShare,
              commentPoints: values?.pointsPerComment,
              downloadPoints: values?.pointsPerDownload,
              notifyAllRelevantUserByGrade:
                values?.notifyAllRelevantUserByGrade,
              notifyAllUserInSystem: values?.notifyAllUserInSystem,
              notifyAllTeachers: values?.notifyAllTeachers,
              notifyAllStudents: values?.notifyAllStudents,
              loggedInUserName: authData?.userName
            },
            contentId: getEffectiveContentId()
          })
        );
      }
    }
  });

  const handlePublishButtonClick = () => {
    dispatch(
      publishContent({
        payload: {
          contentId: getEffectiveContentId(),
          loggedInUserName: authData?.userName,
          status: normalizeContentPublishStatus(
            contentStatus || contentDetails?.status
          ),
          contentType:
            contentDetails?.contentType || formik.values?.contentType?.label
        }
      })
    );
  };

  // Filter grades based on Content Type
  const getFilteredGradeList = () => {
    if (!formik?.values?.contentType?.id) {
      return noAuthGradeList || [];
    }

    if (formik.values.contentType.id === 'State') {
      // For State: Show only grades 1-10
      return (noAuthGradeList || []).filter(
        grade => grade.gradeId >= 1 && grade.gradeId <= 10
      );
    }

    // For All and other types: Show all grades
    return noAuthGradeList || [];
  };

  useEffect(() => {
    dispatch(getNoAuthGradeList());
    dispatch(getThemeList());
    dispatch(getMediumList());
  }, []);

  useEffect(() => {
    if (isPublishContentSuccess) {
      refreshContentDetails();
    }
  }, [isPublishContentSuccess]);

  useEffect(() => {
    if (!isPublishContentLoading && isPublishContentSuccess) {
      dispatch(
        getContentList({
          payload: {
            startDate: null,
            endDate: null,
            dateType: 'all',
            sortBy: null,
            paginationRequest: { type: 'all', page: 0, size: 10 }
          },
          search: '',
          contentType: '',
          status: ''
        })
      );
      setContentId('');
      localStorage.removeItem('localContentId');
      setTimeout(() => {
        navigate('/content-management');
      }, 2000);
    }
  }, [isPublishContentSuccess, isPublishContentLoading]);

  // Inital UseEffect

  useEffect(() => {
    document.title = createTitle('Add new content');
    dispatch(getNoAuthGradeList());
    dispatch(getSectionList());
    dispatch(getTagList());
  }, []);

  useEffect(() => {
    if (!isAddNewTagLoading && isAddNewTagSuccess) {
      dispatch(getTagList());
    }
    if (!isAddNewSectionLoading && isAddNewSectionSuccess) {
      dispatch(getSectionList());
    }
  }, [
    isAddNewTagLoading,
    isAddNewTagSuccess,
    isAddNewSectionSuccess,
    isAddNewSectionLoading
  ]);

  // UseEffect for getDetails

  useEffect(() => {
    if (
      contentDetails &&
      sectionList &&
      noAuthGradeList &&
      tagList &&
      themeList &&
      mediumList
    ) {
      let tempGrade = noAuthGradeList?.filter(
        grade => grade.gradeId === contentDetails?.grade
      );

      let tempTags = tagList?.filter(tag =>
        contentDetails?.contentTags?.some(
          contentTag => contentTag.tagName === tag.tagName
        )
      );

      let tempSection = sectionList?.filter(
        section => section.sectionName === contentDetails?.section
      );

      // Filter theme, medium, unit based on API response structure
      let tempTheme = themeList?.filter(theme => {
        if (!theme) return false;
        return theme.themeName === contentDetails?.theme?.themeName;
      });

      let tempMedium = mediumList?.filter(medium => {
        if (!medium) return false;
        return medium.mediumName === contentDetails?.medium?.mediumName;
      });

      let tempUnit = unitList?.filter(unit => {
        if (!unit) return false;
        return unit.unitName === contentDetails?.unit?.unitName;
      });

      formik.setValues({
        contentTitle: contentDetails?.title || '',
        contentDescription: contentDetails?.description || '',
        grade: tempGrade
          ? { id: tempGrade[0]?.gradeId, label: tempGrade[0]?.gradeName }
          : null,
        tags: isArrayNotEmpty(tempTags)
          ? tempTags?.map(cc => {
              return { id: cc.tagId, label: cc.tagName };
            })
          : [],
        section: tempSection
          ? {
              id: tempSection[0]?.contentSectionId,
              label: tempSection[0]?.sectionName
            }
          : null,
        theme:
          tempTheme && tempTheme.length > 0
            ? { id: tempTheme[0]?.themeId, label: tempTheme[0]?.themeName }
            : null,
        medium:
          tempMedium && tempMedium.length > 0
            ? { id: tempMedium[0]?.mediumId, label: tempMedium[0]?.mediumName }
            : null,
        unit:
          tempUnit && tempUnit.length > 0
            ? { id: tempUnit[0]?.unitId, label: tempUnit[0]?.unitName }
            : null,
        contentType: mapContentTypeToFormOption(contentDetails?.contentType),
        contentVisibility:
          {
            label: contentDetails?.contentVisibility,
            id: contentDetails?.contentVisibility
          } || null,
        likes: contentDetails?.likes || false,
        comments: contentDetails?.comments || false,
        share: contentDetails?.share || false,
        download: contentDetails?.download || false,
        allowPoints: contentDetails?.allowPoints || false,
        pointsPerLike: contentDetails?.likesPoints || 0,
        pointsPerComment: contentDetails?.commentPoints || 0,
        pointsPerDownload: contentDetails?.downloadPoints || 0,
        pointsPerShare: contentDetails?.sharePoints || 0,
        notifyAllRelevantUserByGrade:
          contentDetails?.notifyAllRelevantUserByGrade || false,
        notifyAllStudents: contentDetails?.notifyAllStudents || false,
        notifyAllTeachers: contentDetails?.notifyAllTeachers || false,
        notifyAllUserInSystem: contentDetails?.notifyAllUserInSystem || false
      });
      setGamificationData(contentDetails);
      setFileType(contentDetails?.uploadType);
      setPreviewUrl(contentDetails?.thumbnailFileUrl);
      setFile(contentDetails?.thumbnailFileUrl);
      setFileName(contentDetails?.thumbnailFileName);
      setProgress(100);

      setContentStatus(contentDetails?.status || 'Saved');
      if (contentDetails?.contentId) {
        setContentId(contentDetails.contentId);
        localStorage.setItem('localContentId', contentDetails.contentId);
      }
      const detailsEncryptId = resolveEncryptedIdFromDetails(contentDetails);
      if (detailsEncryptId) {
        setEncryptedId(detailsEncryptId);
      }

      // Load units for the selected grade in edit mode
      if (contentDetails?.grade) {
        dispatch(getUnitsByGrade(contentDetails.grade));
      }
    }
  }, [
    contentDetails,
    noAuthGradeList,
    tagList,
    sectionList,
    themeList,
    mediumList
  ]);

  const simulateUploadProgress = () => {
    let uploadProgress = 0;
    const interval = setInterval(() => {
      uploadProgress += 10;
      setProgress(uploadProgress);
      if (uploadProgress >= 100) clearInterval(interval);
    }, 300); // Simulate upload in steps
  };

  const handleFileUpload = event => {
    const uploadedFile = event.target.files[0];

    const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];

    const isAllowedFileType =
      allowedExtensions.some(ext =>
        uploadedFile.name.toLowerCase().endsWith(ext)
      ) || uploadedFile.type.startsWith('image/');

    if (isAllowedFileType) {
      if (uploadedFile && uploadedFile.size > 10 * 1024 * 1024) {
        setShowError(true);
        setShowErrorMessage(
          'File size exceeds the 10 MB limit. Please upload a smaller file.'
        );
        event.target.value = '';
        return;
      }

      setFile(uploadedFile);
      setFileName(uploadedFile.name);

      const fileType = uploadedFile.name.toLowerCase();

      setFileType(
        fileType.endsWith('.png') ||
          fileType.endsWith('.jpg') ||
          fileType.endsWith('.jpeg') ||
          fileType.endsWith('.gif') ||
          uploadedFile.type.startsWith('image/')
          ? 'Image'
          : ''
      );

      setPreviewUrl(URL.createObjectURL(uploadedFile));

      simulateUploadProgress();
    } else {
      setShowError(true);
      setShowErrorMessage('Uploaded file type is not supported.');
    }
    event.target.value = '';
  };

  const handleRemoveFile = () => {
    setFile(null);
    setProgress(0);
    setFileType('');
  };

  const areAllRequiredFieldsFilled = () => {
    let requiredFieldsFilled = false;
    const effectiveContentId = getEffectiveContentId();
    const isEditMode =
      location.pathname === '/content-management/edit-flashcard' ||
      !!effectiveContentId;

    if (initialValues.tabValue === 0) {
      const contentType = formik.values.contentType?.id;

      // Base required fields
      const baseRequiredFields =
        formik.values.contentTitle &&
        formik.values.grade &&
        formik.values.section &&
        formik.values.contentType?.id &&
        formik.values.contentVisibility?.id &&
        formik.values.medium &&
        (file || (isEditMode && contentDetails?.thumbnailFileUrl));

      // Theme is required for Core, disabled for State
      const themeRequired = isThemeRequiredForContentType(contentType)
        ? formik.values.theme
        : true;
      const unitRequired = isUnitRequiredForContentType(contentType)
        ? resolveUnitId(formik.values.unit)
        : true;

      requiredFieldsFilled =
        baseRequiredFields && themeRequired && unitRequired;
    } else if (initialValues.tabValue === 1) {
      requiredFieldsFilled = !!effectiveContentId;
    } else if (initialValues.tabValue === 2) {
      requiredFieldsFilled = !!effectiveContentId;
    } else if (initialValues.tabValue === 3) {
      const arePointsFieldsFilled = formik?.values?.allowPoints
        ? (!gamificationData?.likes || !!formik.values.pointsPerLike) &&
          (!gamificationData?.share || !!formik.values.pointsPerShare) &&
          (!gamificationData?.comments || !!formik.values.pointsPerComment) &&
          (!gamificationData?.download || !!formik.values.pointsPerDownload)
        : true;

      requiredFieldsFilled = !!effectiveContentId && arePointsFieldsFilled;
    }

    return requiredFieldsFilled;
  };

  const isSaveDisabled = !areAllRequiredFieldsFilled();

  const responseInteractionMenu = [
    { id: 1, menuName: 'Likes', field: 'likes' },
    { id: 2, menuName: 'Comments', field: 'comments' },
    { id: 3, menuName: 'Share', field: 'share' },
    { id: 4, menuName: 'Download', field: 'download' }
  ];

  const handleResponsesSwitchChange = id => {
    const field = RESPONSE_INTERACTION_FIELDS[id];
    if (field) {
      formik.setFieldValue(field, !formik.values[field]);
    }
  };

  const handleSaveAndNext = () => {
    if (isSaveDisabled) {
      return;
    }

    if (initialValues.tabValue === 0) {
      formik.handleSubmit();
      return;
    }

    if (initialValues.tabValue === 1) {
      setInitalValues(prev => ({ ...prev, tabValue: 2 }));
      return;
    }

    if (initialValues.tabValue === 2) {
      dispatch(
        updateContentResponses({
          payload: {
            likes: formik?.values?.likes,
            likesContentType: 'All',
            comments: formik?.values?.comments,
            commentsContentType: 'All',
            share: formik?.values?.share,
            shareContentType: 'All',
            download: formik?.values?.download,
            downloadContentType: 'All',
            loggedInUserName: authData?.userName
          },
          contentId: getEffectiveContentId()
        })
      );
      return;
    }

    if (initialValues.tabValue === 3) {
      formik.handleSubmit();
    }
  };

  const handleCloseNewTagModal = () => {
    setIsNewTagModalOpen(false);
  };

  const handleCloseNewSectionModal = () => {
    setIsNewSectionModalOpen(false);
  };

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
        setShowErrorMessage('');
      }, [2000]);
    }
  }, [showError]);

  useEffect(() => {
    if (Array.isArray(contentDetails?.flashCard)) {
      const questions = contentDetails.flashCard.filter(
        item => item?.questionText || item?.questionId
      );
      setQuestionList(questions);
    }
  }, [contentDetails?.flashCard]);

  useEffect(() => {
    if (
      isSaveFlashCardSuccess ||
      isDeleteQuestionSuccess ||
      isPublishContentSuccess
    ) {
      refreshContentDetails();
    }
  }, [
    isSaveFlashCardSuccess,
    isDeleteQuestionSuccess,
    isPublishContentSuccess
  ]);

  useEffect(() => {
    if (!isDeleteQuestionLoading && isDeleteQuestionSuccess) {
      setIsDeleteModalOpen(false);
    }
  }, [isDeleteQuestionLoading, isDeleteQuestionSuccess]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCloseNewQuestionModal = () => {
    setIsNewQuestionModalOpen(false);
    setEditQuestionData(null);
  };

  const openQuestionModal = (question = null) => {
    dispatch(revertSaveFlashCard());
    setEditQuestionData(question);
    setIsNewQuestionModalOpen(true);
  };

  const handleAddQuestion = newQuestion => {
    setQuestionList(prevList => [...prevList, newQuestion]);
  };

  const handleUpdateQuestions = newQuestion => {
    setQuestionList(prevList =>
      prevList.map(question =>
        question.questionId === newQuestion.questionId ? newQuestion : question
      )
    );
  };

  const handleDeleteModal = id => {
    setIsDeleteModalOpen(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteId(null);
  };

  const handleDeleteQuestion = () => {
    dispatch(
      deleteQuestions({
        id: deleteId || 0,
        userName: authData?.userName || ''
      })
    );
    setDeleteId(null);
  };

  const handleEditQuestion = id => {
    const question = questionList.find(item => item.questionId === id);

    if (question) {
      openQuestionModal(question);
    }
  };

  const itemsPerPage = 10;
  const startIndex = page * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const mappingList = questionList.slice(startIndex, endIndex);

  return (
    <>
      <Grid
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography fontSize={32} fontWeight="700" display={'flex'}>
          {location.pathname === '/content-management/edit-flashcard'
            ? 'Edit Content'
            : 'Add New Flashcard'}
          <Typography
            ml={1}
            fontSize={20}
            fontWeight="700"
            alignSelf={'center'}
          ></Typography>
        </Typography>
        <Grid display={'flex'} gap={2} alignItems={'center'}>
          {initialValues?.tabValue === 3 && (
            <LoadingButton
              onClick={handlePublishButtonClick}
              disabled={isSaveDisabled}
              type="button"
              variant="contained"
              style={{
                height: '42px',
                width: '110px'
              }}
              loading={isPublishContentLoading}
            >
              {contentStatus === 'Saved' ? 'Publish' : 'Unpublish'}
            </LoadingButton>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        display={'flex'}
        flexDirection={'column'}
        elevation={0}
        borderRadius={'8px'}
      >
        <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
          <Grid
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Tabs
              value={initialValues.tabValue}
              onChange={(val, newValue) =>
                setInitalValues({
                  ...initialValues,
                  tabValue: newValue,
                  page: 0
                })
              }
              TabIndicatorProps={{
                sx: {
                  height: '4px',
                  borderRadius: '4px'
                }
              }}
            >
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 0 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 0
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 3C12.6975 3 13.0462 3 13.3323 3.07667C14.1088 3.28472 14.7153 3.8912 14.9233 4.66766C15 4.95378 15 5.30252 15 6V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V6C3 5.30252 3 4.95378 3.07667 4.66766C3.28472 3.8912 3.8912 3.28472 4.66766 3.07667C4.95378 3 5.30252 3 6 3M6 11.625H10.125M6.08175 8.625H11.625M7.2 4.5H10.8C11.22 4.5 11.4301 4.5 11.5905 4.41826C11.7316 4.34635 11.8463 4.23161 11.9183 4.09049C12 3.93006 12 3.72004 12 3.3V2.7C12 2.27996 12 2.06994 11.9183 1.90951C11.8463 1.76839 11.7316 1.65365 11.5905 1.58175C11.4301 1.5 11.22 1.5 10.8 1.5H7.2C6.77996 1.5 6.56994 1.5 6.40951 1.58175C6.26839 1.65365 6.15365 1.76839 6.08175 1.90951C6 2.06994 6 2.27996 6 2.7V3.3C6 3.72004 6 3.93006 6.08175 4.09049C6.15365 4.23161 6.26839 4.34635 6.40951 4.41826C6.56994 4.5 6.77996 4.5 7.2 4.5Z"
                        stroke={
                          initialValues.tabValue === 0
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Overview"
                    count={0}
                    selected={initialValues.tabValue === 0}
                    isCountRequired={false}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 1 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 1
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 9H6M12 12.375H6M12 5.625H6M15 5.1V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V5.1C3 3.83988 3 3.20982 3.24524 2.72852C3.46095 2.30516 3.80516 1.96095 4.22852 1.74524C4.70982 1.5 5.33988 1.5 6.6 1.5H11.4C12.6601 1.5 13.2902 1.5 13.7715 1.74524C14.1948 1.96095 14.539 2.30516 14.7548 2.72852C15 3.20982 15 3.83988 15 5.1Z"
                        stroke={
                          initialValues.tabValue === 1
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                disabled={!getEffectiveContentId()}
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Question list"
                    count={0}
                    selected={initialValues.tabValue === 1}
                    isCountRequired={false}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 2 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 2
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="12"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 9H4M10 12.375H4M10 5.625H4M13 5.1V12.9C13 14.1601 13 14.7902 12.7548 15.2715C12.539 15.6948 12.1948 16.039 11.7715 16.2548C11.2902 16.5 10.6601 16.5 9.4 16.5H4.6C3.33988 16.5 2.70982 16.5 2.22852 16.2548C1.80516 16.039 1.46095 15.6948 1.24524 15.2715C1 14.7902 1 14.1601 1 12.9V5.1C1 3.83988 1 3.20982 1.24524 2.72852C1.46095 2.30516 1.80516 1.96095 2.22852 1.74524C2.70982 1.5 3.33988 1.5 4.6 1.5H9.4C10.6601 1.5 11.2902 1.5 11.7715 1.74524C12.1948 1.96095 12.539 2.30516 12.7548 2.72852C13 3.20982 13 3.83988 13 5.1Z"
                        stroke={
                          initialValues.tabValue === 2
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                disabled={!getEffectiveContentId()}
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Responses and Interactions"
                    count={0}
                    selected={initialValues.tabValue === 2}
                    isCountRequired={false}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  fontWeight: initialValues.tabValue === 3 ? '700' : '600',
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 3
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="13.5"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.04628 14.5283L6.48462 15.5142C6.61492 15.8076 6.82757 16.057 7.09678 16.232C7.366 16.4069 7.6802 16.5001 8.00128 16.5C8.32237 16.5001 8.63657 16.4069 8.90578 16.232C9.17499 16.057 9.38764 15.8076 9.51795 15.5142L9.95628 14.5283C10.1123 14.1785 10.3748 13.8869 10.7063 13.695C11.0399 13.5026 11.4258 13.4206 11.8088 13.4608L12.8813 13.575C13.2005 13.6088 13.5227 13.5492 13.8088 13.4035C14.0949 13.2578 14.3325 13.0322 14.4929 12.7542C14.6536 12.4763 14.7301 12.1577 14.7132 11.8372C14.6964 11.5166 14.5869 11.2079 14.3979 10.9483L13.7629 10.0758C13.5368 9.76285 13.416 9.38611 13.4179 9C13.4179 8.61494 13.5398 8.23976 13.7663 7.92833L14.4013 7.05583C14.5902 6.79632 14.6997 6.48755 14.7166 6.16701C14.7334 5.84646 14.6569 5.52791 14.4963 5.25C14.3359 4.97193 14.0982 4.74637 13.8121 4.60067C13.5261 4.45497 13.2039 4.3954 12.8846 4.42917L11.8121 4.54333C11.4291 4.58356 11.0432 4.50159 10.7096 4.30917C10.3775 4.11619 10.1149 3.82302 9.95962 3.47167L9.51795 2.48583C9.38764 2.19238 9.17499 1.94304 8.90578 1.76805C8.63657 1.59306 8.32237 1.49995 8.00128 1.5C7.6802 1.49995 7.366 1.59306 7.09678 1.76805C6.82757 1.94304 6.61492 2.19238 6.48462 2.48583L6.04628 3.47167C5.89098 3.82302 5.62844 4.11619 5.29628 4.30917C4.96269 4.50159 4.57678 4.58356 4.19378 4.54333L3.11795 4.42917C2.7987 4.3954 2.4765 4.45497 2.19043 4.60067C1.90437 4.74637 1.66671 4.97193 1.50628 5.25C1.34565 5.52791 1.26912 5.84646 1.28598 6.16701C1.30285 6.48755 1.41237 6.79632 1.60128 7.05583L2.23628 7.92833C2.46274 8.23976 2.58468 8.61494 2.58461 9C2.58468 9.38506 2.46274 9.76024 2.23628 10.0717L1.60128 10.9442C1.41237 11.2037 1.30285 11.5124 1.28598 11.833C1.26912 12.1535 1.34565 12.4721 1.50628 12.75C1.66687 13.0279 1.90455 13.2534 2.19058 13.399C2.47661 13.5447 2.79872 13.6044 3.11795 13.5708L4.19045 13.4567C4.57345 13.4164 4.95936 13.4984 5.29295 13.6908C5.62634 13.8833 5.89011 14.1765 6.04628 14.5283Z"
                        stroke={
                          initialValues.tabValue === 3
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.99994 11.25C9.24258 11.25 10.2499 10.2426 10.2499 9C10.2499 7.75736 9.24258 6.75 7.99994 6.75C6.7573 6.75 5.74994 7.75736 5.74994 9C5.74994 10.2426 6.7573 11.25 7.99994 11.25Z"
                        stroke={
                          initialValues.tabValue === 3
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                disabled={!getEffectiveContentId()}
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Settings"
                    count={0}
                    selected={initialValues.tabValue === 3}
                    isCountRequired={false}
                  />
                }
              />
            </Tabs>
          </Grid>
        </Grid>
      </Grid>

      {initialValues?.tabValue === 0 && (
        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ paddingX: '14px', pt: 1 }}
        >
          <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              width={'912px'}
            >
              <Box>
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Title
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <TextField
                      maxRows={4}
                      name="contentTitle"
                      placeholder="Enter interesting title for the user "
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 200 }}
                      value={formik.values?.contentTitle}
                      onChange={formik.handleChange}
                      error={
                        formik.touched?.contentTitle &&
                        Boolean(formik.errors?.contentTitle)
                      }
                    />
                    <div
                      style={{
                        display: 'flex',
                        // justifyContent: 'space-between'
                        justifyContent: 'flex-end'
                      }}
                    >
                      <FormHelperText id="contentTitle">
                        {formik.touched?.contentTitle &&
                          formik.errors?.contentTitle}
                      </FormHelperText>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        // textAlign={'end'}
                      >
                        {formik.values?.contentTitle
                          ? formik.values?.contentTitle?.length
                          : 0}
                        /200
                      </Typography>
                    </div>
                  </FormControl>
                  {/* </Grid> */}
                </Box>

                {/* Description */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    // required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Description
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <TextField
                      name="contentDescription"
                      placeholder="Add description"
                      variant="outlined"
                      size="small"
                      maxRows={3}
                      sx={{
                        '& textarea': {
                          '&::-webkit-scrollbar': {
                            width: '0.2em'
                          },
                          '&::-webkit-scrollbar-track': {
                            background: '#f5f5f5',
                            width: '3px',
                            borderRadius: '10px'
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#4E565F',
                            borderRadius: '10px',
                            border: '2px solid #4E565F'
                          }
                        }
                      }}
                      inputProps={{
                        maxLength: 300
                      }}
                      multiline
                      value={formik.values?.contentDescription}
                      error={
                        formik.touched?.contentDescription &&
                        Boolean(formik.errors?.contentDescription)
                      }
                      onChange={formik.handleChange}
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <FormHelperText id="contentDescription">
                        {formik.touched?.contentDescription &&
                          formik.errors?.contentDescription}
                      </FormHelperText>
                      <Typography variant="body2" color="textSecondary">
                        {formik.values?.contentDescription
                          ? formik.values?.contentDescription?.length
                          : 0}
                        /300
                      </Typography>
                    </div>
                  </FormControl>
                </Box>

                {/* Content Type */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Content type
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik.values?.contentType}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('contentType', newValue);
                        // Reset dependent fields when Content Type changes
                        formik.setFieldValue('grade', null);
                        formik.setFieldValue('theme', null);
                        formik.setFieldValue('unit', null);

                        // If Core is selected, also clear unit since it won't be visible
                        if (newValue?.id === 'Core') {
                          formik.setFieldValue('unit', null);
                        }
                      }}
                      getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={ALLOWED_CONTENT_TYPE_OPTIONS}
                      renderInput={params => (
                        <TextField
                          name="contentType"
                          {...params}
                          placeholder="Select content type"
                          error={
                            formik.touched?.contentType &&
                            Boolean(formik.errors?.contentType)
                          }
                          helperText={
                            formik.touched?.contentType &&
                            formik.errors?.contentType
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Grade */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Grade
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.grade}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('grade', newValue);
                        if (newValue?.id) {
                          dispatch(getUnitsByGrade(newValue.id));
                        } else {
                          formik.setFieldValue('unit', null);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(getFilteredGradeList())
                          ? getFilteredGradeList().map(c => {
                              return {
                                label: c.gradeName,
                                id: c.gradeId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="grade"
                          {...params}
                          placeholder="Select grade"
                          error={
                            formik.touched?.grade &&
                            Boolean(formik.errors?.grade)
                          }
                          helperText={
                            formik.touched?.grade && formik.errors?.grade
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Tags */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Tags
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.tags || []}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('tags', newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.id === (value ? value.id : null)
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(tagList)
                          ? tagList
                              .map(c => ({
                                label: c.tagName,
                                id: c.contentTagId
                              }))
                              .filter(
                                option =>
                                  !formik.values?.tags?.some(
                                    tag => tag.id === option.id
                                  )
                              )
                          : []
                      }
                      disableClearable
                      multiple
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            size="small"
                            color="secondary"
                            key={index}
                            label={option.label || option.tagName}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                      renderInput={params => (
                        <TextField
                          name="tags"
                          {...params}
                          placeholder="Select tag"
                          sx={{
                            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingLeft: '12px'
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                {/* <svg
                                  width="17"
                                  height="16"
                                  viewBox="0 0 17 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.83334 5.3335H5.84001M1.83334 3.46683L1.83334 6.44984C1.83334 6.77596 1.83334 6.93902 1.87018 7.09247C1.90285 7.22852 1.95672 7.35858 2.02982 7.47787C2.11228 7.61243 2.22758 7.72773 2.45818 7.95833L7.5706 13.0708C8.36264 13.8628 8.75865 14.2588 9.21531 14.4072C9.617 14.5377 10.0497 14.5377 10.4514 14.4072C10.908 14.2588 11.3041 13.8628 12.0961 13.0708L13.5706 11.5962C14.3626 10.8042 14.7587 10.4082 14.907 9.95153C15.0375 9.54984 15.0375 9.11715 14.907 8.71546C14.7587 8.2588 14.3626 7.86279 13.5706 7.07075L8.45818 1.95833C8.22758 1.72773 8.11228 1.61243 7.97772 1.52998C7.85843 1.45687 7.72837 1.403 7.59232 1.37034C7.43887 1.3335 7.27581 1.3335 6.94969 1.3335L3.96668 1.3335C3.21994 1.3335 2.84657 1.3335 2.56136 1.47882C2.31047 1.60665 2.1065 1.81063 1.97867 2.06151C1.83334 2.34672 1.83334 2.72009 1.83334 3.46683ZM6.16668 5.3335C6.16668 5.51759 6.01744 5.66683 5.83334 5.66683C5.64925 5.66683 5.50001 5.51759 5.50001 5.3335C5.50001 5.1494 5.64925 5.00016 5.83334 5.00016C6.01744 5.00016 6.16668 5.1494 6.16668 5.3335Z"
                                    stroke={colorTextGrey}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg> */}

                                {/* {params.InputProps.startAdornment} */}
                              </>
                            )
                          }}
                          error={
                            formik.touched?.tags && Boolean(formik.errors?.tags)
                          }
                          helperText={
                            formik.touched?.tags && formik.errors?.tags
                          }
                        />
                      )}
                    />
                    <Box display={'flex'} flexWrap={'wrap'}>
                      {isArrayNotEmpty(formik.values?.tags) &&
                        formik.values?.tags.map((cc, indiIdx) => {
                          return (
                            <Typography
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: 1,
                                mr: 1,
                                fontWeight: '600',
                                padding: '2px 6px',
                                background: colorSecondary,
                                borderRadius: '6px',
                                border: `1px solid ${colorPrimary}`
                              }}
                              key={indiIdx}
                              variant="caption"
                            >
                              {cc?.label || cc?.tagName}
                              <IconButton
                                onClick={() => {
                                  const newTags = [...formik.values.tags];
                                  newTags.splice(indiIdx, 1);
                                  formik.setFieldValue('tags', newTags);
                                }}
                                sx={{
                                  padding: 0,
                                  ml: 2
                                }}
                              >
                                <Close fontSize="small" color="action" />
                              </IconButton>
                            </Typography>
                          );
                        })}
                    </Box>
                  </FormControl>
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between'
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Tooltip placement="top" title="Click to add new tag">
                      <Button
                        sx={{
                          height: 30,
                          color: isHover ? colorPrimary : colorTextBlack,
                          borderBottom: `1px solid ${isHover ? colorPrimary : colorTextBlack}`,
                          borderRadius: 0
                        }}
                        onClick={() => {
                          setIsNewTagModalOpen(true);
                        }}
                        size="small"
                      >
                        <SvgIcon
                          fontSize="small"
                          sx={{
                            marginRight: 0.6,
                            height: '16px',
                            width: '16px'
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                              stroke={isHover ? colorPrimary : colorTextBlack}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        Add new tag
                      </Button>
                    </Tooltip>
                  </div>
                </Box>

                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Section
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.section}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('section', newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.id === (value ? value.id : null)
                      }
                      getOptionLabel={getOptionLabel}
                      // options={sectionList}
                      options={
                        isArrayNotEmpty(sectionList)
                          ? sectionList.map(c => {
                              return {
                                label: c.sectionName,
                                id: c.contentSectionId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="section"
                          {...params}
                          placeholder="Select section"
                          error={
                            formik.touched?.section &&
                            Boolean(formik.errors?.section)
                          }
                          helperText={
                            formik.touched?.section && formik.errors?.section
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between'
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Tooltip placement="top" title="Click to add new section">
                      <Button
                        sx={{
                          height: 30,
                          color: isHover ? colorPrimary : colorTextBlack,
                          borderBottom: `1px solid ${isHover ? colorPrimary : colorTextBlack}`,
                          borderRadius: 0
                        }}
                        onClick={() => {
                          setIsNewSectionModalOpen(true);
                        }}
                        size="small"
                      >
                        <SvgIcon
                          fontSize="small"
                          sx={{
                            marginRight: 0.6,
                            height: '16px',
                            width: '16px'
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                              stroke={isHover ? colorPrimary : colorTextBlack}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        Add new section
                      </Button>
                    </Tooltip>
                  </div>
                </Box>

                {/* Theme - Show only when Content Type is selected */}
                {formik.values?.contentType?.id && (
                  <Box width={'416px'} mb={2}>
                    <InputLabel
                      required={isThemeRequiredForContentType(
                        formik.values?.contentType?.id
                      )}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Theme
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        disabled={formik.values?.contentType?.id === 'State'}
                        value={formik?.values?.theme}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('theme', newValue);
                          // Reset unit when theme changes
                          formik.setFieldValue('unit', null);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          value ? matchId(option.id, value.id) : false
                        }
                        getOptionLabel={getOptionLabel}
                        options={
                          isArrayNotEmpty(themeList)
                            ? themeList.map(t => {
                                return {
                                  label: t.themeName,
                                  id: t.themeId
                                };
                              })
                            : []
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            name="theme"
                            {...params}
                            placeholder="Select theme"
                            error={
                              formik.touched?.theme &&
                              Boolean(formik.errors?.theme)
                            }
                            helperText={
                              formik.touched?.theme && formik.errors?.theme
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Box>
                )}

                {/* Medium */}
                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Medium
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik?.values?.medium}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('medium', newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        value ? matchId(option.id, value.id) : false
                      }
                      getOptionLabel={getOptionLabel}
                      options={
                        isArrayNotEmpty(mediumList)
                          ? mediumList.map(m => {
                              return {
                                label: m.mediumName,
                                id: m.mediumId
                              };
                            })
                          : []
                      }
                      disableClearable
                      renderInput={params => (
                        <TextField
                          name="medium"
                          {...params}
                          placeholder="Select medium"
                          error={
                            formik.touched?.medium &&
                            Boolean(formik.errors?.medium)
                          }
                          helperText={
                            formik.touched?.medium && formik.errors?.medium
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>

                {/* Unit is required for State — Hide when Core is selected */}
                {formik.values?.contentType?.id !== 'Core' && (
                  <Box width={'416px'} mb={2}>
                    <InputLabel
                      required={isUnitRequiredForContentType(
                        formik.values?.contentType?.id
                      )}
                      sx={{
                        fontWeight: '700',
                        color: colorTextBlack,
                        fontSize: '16px',
                        mb: 0.6
                      }}
                    >
                      Unit
                    </InputLabel>
                    <FormControl variant="outlined" fullWidth size="small">
                      <Autocomplete
                        size="small"
                        value={formik?.values?.unit || null}
                        onChange={(event, newValue) => {
                          formik.setFieldValue('unit', newValue);
                        }}
                        disabled={!formik?.values?.grade}
                        isOptionEqualToValue={(option, value) =>
                          value ? matchId(option.id, value.id) : false
                        }
                        getOptionLabel={option => option?.label || ''}
                        options={
                          isArrayNotEmpty(unitList)
                            ? unitList
                                .map(u => ({
                                  label: u.unitName,
                                  id: u.unitId
                                }))
                                .filter(option => option?.id != null)
                            : []
                        }
                        renderInput={params => (
                          <TextField
                            name="unit"
                            {...params}
                            placeholder="Select unit"
                            error={
                              formik.touched?.unit &&
                              Boolean(formik.errors?.unit)
                            }
                            helperText={
                              formik.touched?.unit && formik.errors?.unit
                            }
                          />
                        )}
                        ListboxProps={{
                          sx: {
                            '& .MuiAutocomplete-option:hover': {
                              backgroundColor: colorSecondary
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </Box>
                )}

                <Box width={'416px'} mb={2}>
                  <InputLabel
                    required
                    sx={{
                      fontWeight: '700',
                      color: colorTextBlack,
                      fontSize: '16px',
                      mb: 0.6
                    }}
                  >
                    Content Visibility
                  </InputLabel>
                  <FormControl variant="outlined" fullWidth size="small">
                    <Autocomplete
                      size="small"
                      value={formik.values?.contentVisibility}
                      onChange={(event, newValue) => {
                        formik.setFieldValue('contentVisibility', newValue);
                      }}
                      disableClearable
                      isOptionEqualToValue={(option, value) =>
                        option.id === (value ? value.id : null)
                      }
                      getOptionLabel={getOptionLabel}
                      options={[
                        { label: 'Private', id: 'Private' },
                        { label: 'Published', id: 'Published' }
                      ]}
                      renderInput={params => (
                        <TextField
                          name="contentVisibility"
                          {...params}
                          placeholder="Select content visibility"
                          error={
                            formik.touched?.contentVisibility &&
                            Boolean(formik.errors?.contentVisibility)
                          }
                          helperText={
                            formik.touched?.contentVisibility &&
                            formik.errors?.contentVisibility
                          }
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box>
                <InputLabel
                  required
                  sx={{
                    fontWeight: '700',
                    color: colorTextBlack,
                    fontSize: '16px',
                    mb: 0.6
                  }}
                >
                  Upload Thumbnail
                </InputLabel>
                {!file && (
                  <Box
                    width={'416px'}
                    mb={2}
                    border={'1px dashed #ccc'}
                    display="flex"
                    borderRadius={'8px'}
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height={'150px'}
                    onDrop={e => {
                      e.preventDefault();
                      handleFileUpload({
                        target: { files: e.dataTransfer.files }
                      });
                    }}
                    onDragOver={e => e.preventDefault()}
                  >
                    {/* Upload Icon with Custom Color */}
                    <Box
                      sx={{
                        height: '24px',
                        width: '24px',
                        color: '#CBD2D9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2
                      }}
                    >
                      <UploadIcon sx={{ color: '#CBD2D9' }} />
                    </Box>

                    {/* Combined Text Line */}
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      fontSize={'16px'}
                      color={colorLinkGrey}
                      marginBottom={1}
                    >
                      Drag and drop or{' '}
                      <Typography
                        component="label"
                        variant="body2"
                        fontWeight={600}
                        fontSize={'16px'}
                        color="#CBD2D9"
                        sx={{
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        browse
                        <input type="file" hidden onChange={handleFileUpload} />
                      </Typography>{' '}
                      your file
                    </Typography>

                    <Typography
                      color={colorLinkGrey}
                      fontSize={'12px'}
                      fontWeight={500}
                      paddingX={4}
                    >
                      Supported file types: jpg, png, gif (Maximum size : 10 MB)
                    </Typography>
                  </Box>
                )}

                {file && (
                  <Box mt={2} width={'416px'}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={1}
                      border="1px solid #E4E7EB"
                      borderRadius="8px"
                      paddingX="12px"
                      paddingY="4px"
                    >
                      <Box display="flex" alignItems="center">
                        {fileType === 'Image' ? (
                          <SvgIcon
                            fontSize="small"
                            sx={{ fontSize: 18, marginRight: 1 }}
                          >
                            <svg
                              width="12"
                              height="16"
                              viewBox="0 0 12 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.8 13H3.62091C3.21704 13 3.0151 13 2.92159 12.9201C2.84045 12.8508 2.79739 12.7469 2.80577 12.6405C2.81541 12.5179 2.95821 12.3751 3.24379 12.0895L8.91242 6.42091C9.17643 6.15691 9.30844 6.0249 9.46066 5.97544C9.59455 5.93193 9.73878 5.93193 9.87268 5.97544C10.0249 6.0249 10.1569 6.1569 10.4209 6.42091L13 9V9.8M9.8 13C10.9201 13 11.4802 13 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C13 11.4802 13 10.9201 13 9.8M9.8 13H4.2C3.0799 13 2.51984 13 2.09202 12.782C1.71569 12.5903 1.40973 12.2843 1.21799 11.908C1 11.4802 1 10.9201 1 9.8V4.2C1 3.0799 1 2.51984 1.21799 2.09202C1.40973 1.71569 1.71569 1.40973 2.09202 1.21799C2.51984 1 3.0799 1 4.2 1H9.8C10.9201 1 11.4802 1 11.908 1.21799C12.2843 1.40973 12.5903 1.71569 12.782 2.09202C13 2.51984 13 3.0799 13 4.2V9.8M6 4.66667C6 5.40305 5.40305 6 4.66667 6C3.93029 6 3.33333 5.40305 3.33333 4.66667C3.33333 3.93029 3.93029 3.33333 4.66667 3.33333C5.40305 3.33333 6 3.93029 6 4.66667Z"
                                stroke="#1F2933"
                                strokeWidth="1.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        ) : (
                          ''
                        )}
                        <Typography
                          variant="body1"
                          color={colorTextBlack}
                          fontSize={'12px'}
                          fontWeight={600}
                        >
                          {fileName}
                        </Typography>
                      </Box>
                      <IconButton onClick={handleRemoveFile} size="small">
                        {/* <CloseOutlined fontSize="small" /> */}
                        <SvgIcon fontSize="small" sx={{ fontSize: 14 }}>
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.33329 1.66699L1.66663 8.33366M1.66663 1.66699L8.33329 8.33366"
                              stroke="#1F2933"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                      </IconButton>
                    </Box>
                    {progress !== 100 && (
                      <>
                        <Typography
                          variant="body2"
                          color={colorLinkGrey}
                          fontSize={'12px'}
                          fontWeight={500}
                        >
                          {progress === 100
                            ? `${progress} % completed`
                            : `Upload Progress: ${progress} %`}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={progress}
                          sx={{
                            mt: 1,
                            '& .MuiLinearProgress-bar': {
                              backgroundColor:
                                progress === 100 ? '#749E35' : undefined
                            }
                          }}
                        />
                      </>
                    )}
                  </Box>
                )}
                {file && progress === 100 && (
                  <Box mt={2} width={'416px'}>
                    <Card
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        maxWidth: '416px',
                        border: '1px solid #e0e0e0',
                        boxShadow: 'none',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        mt: 2,
                        padding: '12px'
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          width: '100%',
                          height: '244px',
                          backgroundColor: '#f0f0f0',
                          borderRadius: '8px',
                          overflow: 'hidden'
                        }}
                      >
                        <img
                          src={previewUrl}
                          alt="Uploaded thumbnail"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                          }}
                        />
                      </Box>
                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            display: '-webkit-box',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            lineHeight: '20px'
                            // marginBottom: '8px',
                            // height: '39px'
                          }}
                        >
                          {formik?.values?.contentTitle}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {initialValues?.tabValue === 1 && (
        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ paddingX: '14px', pt: 1, minHeight: '60vh' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '5px'
            }}
          >
            <Button
              sx={{
                width: '203px',
                height: '42px',
                boxShadow: 'none',
                fontWeight: '700',
                fontSize: '14px'
              }}
              variant="contained"
              onClick={() => openQuestionModal()}
            >
              <SvgIcon
                fontSize="small"
                sx={{ marginRight: 0.6, height: '16px', width: '16px' }}
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                    stroke="#1F2933"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SvgIcon>
              Add New Question
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: questionList.length !== 0 && 'column',
              minHeight: questionList.length == 0 && '60vh',
              alignItems: questionList.length == 0 && 'center',
              marginTop: questionList.length !== 0 && '20px'
            }}
          >
            {questionList.length > 0 ? (
              mappingList.map((item, index) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                      border: `1px solid ${colorDisableGrey}`,
                      borderRadius: '8px',
                      padding: '5px',
                      marginBottom: '6px'
                    }}
                    key={item.questionId || index}
                  >
                    <Typography
                      style={{
                        fontSize: '16px',
                        fontWeight: 700,
                        fontFamily: 'Lato',
                        lineHeight: '20px',
                        color: colorTextBlack,
                        marginLeft: '10px'
                      }}
                    >
                      {item.questionText}
                    </Typography>
                    <div style={{ display: 'flex', marginRight: '20px' }}>
                      <Tooltip title="Edit">
                        <IconButton
                          aria-label="edit"
                          onClick={() => handleEditQuestion(item.questionId)}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.1665 3.33417H5.6665C4.26637 3.33417 3.56631 3.33417 3.03153 3.60666C2.56112 3.84634 2.17867 4.22879 1.93899 4.6992C1.6665 5.23398 1.6665 5.93404 1.6665 7.33417V14.3342C1.6665 15.7343 1.6665 16.4344 1.93899 16.9691C2.17867 17.4396 2.56112 17.822 3.03153 18.0617C3.56631 18.3342 4.26637 18.3342 5.6665 18.3342H12.6665C14.0666 18.3342 14.7667 18.3342 15.3015 18.0617C15.7719 17.822 16.1543 17.4396 16.394 16.9691C16.6665 16.4344 16.6665 15.7343 16.6665 14.3342V10.8342M6.66648 13.3342H8.06193C8.46959 13.3342 8.67341 13.3342 8.86522 13.2881C9.03528 13.2473 9.19786 13.18 9.34698 13.0886C9.51517 12.9855 9.6593 12.8414 9.94755 12.5531L17.9165 4.58417C18.6069 3.89382 18.6069 2.77453 17.9165 2.08417C17.2261 1.39382 16.1069 1.39382 15.4165 2.08417L7.44753 10.0531C7.15928 10.3414 7.01515 10.4855 6.91208 10.6537C6.8207 10.8028 6.75336 10.9654 6.71253 11.1355C6.66648 11.3273 6.66648 11.5311 6.66648 11.9387V13.3342Z"
                              stroke="#1F2933"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          aria-label="delete"
                          style={{ marginLeft: '10px' }}
                          onClick={() => handleDeleteModal(item.questionId)}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                              stroke="#1F2933"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <img
                  src={FLASHCARD_ICON}
                  alt=""
                  style={{
                    width: '130px',
                    height: '130px',
                    objectFit: 'fill'
                  }}
                />
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '20px',
                    fontWeight: 700,
                    color: colorLinkGrey,
                    lineHeight: '26px'
                  }}
                >
                  {
                    " You don't have a question list here. Please add questions for this flashcard."
                  }
                </Typography>
              </div>
            )}

            {questionList.length > 10 && (
              <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <CustomPagination
                  count={questionList.length}
                  page={page}
                  rowsPerPage={10}
                  paginationLabelMode={false}
                  onPageChange={handleChangePage}
                />
              </div>
            )}
          </div>
        </Grid>
      )}

      {initialValues?.tabValue === 2 &&
        responseInteractionMenu.map(item => (
          <Box key={item.id} borderRadius={5} marginBottom={1}>
            <Accordion bgcolor={'white'} expanded={false} elevation={0}>
              <AccordionSummary
                aria-controls={`panel-${item.id}-content`}
                id={`panel-${item.id}-header`}
                sx={{ height: 58, borderRadius: '8px' }}
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    margin: '7px 0px'
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={'700'}
                    fontSize={'20px'}
                  >
                    {item.menuName}
                  </Typography>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={Boolean(formik.values[item.field])}
                        onChange={e => {
                          e.stopPropagation();
                          handleResponsesSwitchChange(item.id);
                        }}
                        onClick={e => e.stopPropagation()}
                      />
                    }
                  />
                </Box>
              </AccordionSummary>
            </Accordion>
          </Box>
        ))}

      {initialValues?.tabValue === 3 && (
        <>
          <Box borderRadius={5} marginBottom={2}>
            <Accordion
              bgcolor={'white'}
              expanded={formik?.values?.allowPoints}
              elevation={0}
            >
              <AccordionSummary sx={{ height: 58, borderRadius: '8px' }}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    margin: '7px 0px'
                  }}
                >
                  <Typography
                    variant="body1"
                    fontSize={'20px'}
                    fontWeight={'700'}
                    color={colorTextBlack}
                  >
                    Gamification
                  </Typography>
                  <FormControlLabel
                    sx={{
                      marginRight: '12px',
                      '& .MuiFormControlLabel-label': {
                        color: '#4E565F',
                        fontSize: '16px',
                        fontWeight: '700',
                        marginRight: '8px'
                      }
                    }}
                    label="Allow points"
                    labelPlacement="start"
                    control={
                      <IOSSwitch
                        checked={formik.values?.allowPoints}
                        onChange={() => {
                          formik.setFieldValue(
                            'allowPoints',
                            !formik.values?.allowPoints
                          );
                        }}
                        onClick={e => e.stopPropagation()}
                      />
                    }
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2} style={{ marginTop: '-30px' }}>
                  {[
                    {
                      label: 'Points per like',
                      field: 'pointsPerLike',
                      required: gamificationData?.likes
                    },
                    {
                      label: 'Points per comment',
                      field: 'pointsPerComment',
                      required: gamificationData?.comments
                    },
                    {
                      label: 'Points per download',
                      field: 'pointsPerDownload',
                      required: gamificationData?.download
                    },
                    {
                      label: 'Points per share',
                      field: 'pointsPerShare',
                      required: gamificationData?.share
                    }
                  ].map(({ label, field, required }) => (
                    <Grid lg={3} item key={field}>
                      <InputLabel
                        required={required || false}
                        sx={{
                          fontWeight: '700',
                          color: colorTextBlack,
                          fontSize: '16px',
                          mb: 0.6
                        }}
                      >
                        {label}
                      </InputLabel>
                      <FormControl variant="outlined" fullWidth size="small">
                        <Autocomplete
                          size="small"
                          value={formik.values?.[field]}
                          onChange={(event, newValue) => {
                            formik.setFieldValue(field, newValue);
                          }}
                          disableClearable
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          getOptionLabel={option => option || ''}
                          options={['5', '10', '15', '20']}
                          renderInput={params => (
                            <TextField
                              name={field}
                              {...params}
                              placeholder={`Select ${label.toLowerCase()}`}
                            />
                          )}
                          ListboxProps={{
                            sx: {
                              '& .MuiAutocomplete-option:hover': {
                                backgroundColor: colorSecondary
                              }
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box borderRadius={5} marginBottom={1} bgcolor={'white'}>
            <Typography
              variant="body1"
              fontSize={'20px'}
              fontWeight={'700'}
              color={colorTextBlack}
              marginX={2}
              marginBottom={0.5}
              paddingTop={2}
            >
              Notification
            </Typography>
            <CustomAccordion
              title="Notify all users in the relevant grade"
              checked={formik?.values?.notifyAllRelevantUserByGrade}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllRelevantUserByGrade',
                  !formik?.values?.notifyAllRelevantUserByGrade
                );
              }}
            />
            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all students"
              checked={formik?.values?.notifyAllStudents}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllStudents',
                  !formik?.values?.notifyAllStudents
                );
              }}
            />
            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all teachers"
              checked={formik?.values?.notifyAllTeachers}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllTeachers',
                  !formik?.values?.notifyAllTeachers
                );
              }}
            />
            <Divider
              sx={{ width: '97%', mx: 'auto' }}
              orientation="horizontal"
            />
            <CustomAccordion
              title="Notify all users in the system"
              checked={formik?.values?.notifyAllUserInSystem}
              onClick={e => e.stopPropagation()}
              onChange={() => {
                formik.setFieldValue(
                  'notifyAllUserInSystem',
                  !formik?.values?.notifyAllUserInSystem
                );
              }}
            />
          </Box>
        </>
      )}

      <Box bgcolor={'white'} padding={2} borderRadius={'8px'} marginTop={2}>
        <Grid display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => {
              localStorage.removeItem('localContentId');
              setContentId('');
              setInitalValues({
                ...initialValues,
                tabValue: 0
              });
              dispatch(revertAllAddContentData());
              navigate('/content-management');
            }}
            sx={{
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>

          <LoadingButton
            onClick={handleSaveAndNext}
            disabled={isSaveDisabled}
            type="button"
            variant="contained"
            style={{
              height: '42px',
              width: '110px'
            }}
            loading={
              initialValues?.tabValue === 0
                ? location.pathname === '/content-management/edit-flashcard' ||
                  getEffectiveContentId()
                  ? isUpadteContentLoading
                  : isAddNewContentLoading
                : initialValues?.tabValue === 2
                  ? isUpadteContentResponsesLoading
                  : initialValues?.tabValue === 3
                    ? isUpadteContentSettingsLoading
                    : false
            }
          >
            {initialValues?.tabValue < 3 ? 'Save & Next' : 'Save'}
          </LoadingButton>
        </Grid>
      </Box>

      <AddNewTagModal
        open={isNewTagModalOpen}
        handleClose={handleCloseNewTagModal}
      />

      <AddNewSectionModal
        open={isNewSectionModalOpen}
        handleClose={handleCloseNewSectionModal}
      />

      {!isAddNewTagLoading && isAddNewTagSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addTagResponse?.message)}
        />
      )}

      {!isAddNewTagLoading && isAddNewTagFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewTagErrorContainer?.errorMessage)}
        />
      )}

      {!isAddNewSectionLoading && isAddNewSectionSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addSectionResponse?.message)}
        />
      )}

      {!isAddNewSectionLoading && isAddNewSectionFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewSectionErrorContainer?.errorMessage)}
        />
      )}

      {showError && (
        <SnackBarBox type="error" message={handleError(showErrorMessage)} />
      )}

      {!isAddNewContentLoading && isAddNewContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(addContentResponse?.payload?.message)}
        />
      )}

      {!isAddNewContentLoading && isAddNewContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(addNewContentErrorContainer?.errorMessage)}
        />
      )}

      {!isUpadteContentLoading && isUpadteContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError('Content updated successfully.')}
        />
      )}

      {!isUpadteContentLoading && isUpadteContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(upadteContentErrorContainer?.errorMessage)}
        />
      )}

      {!isPublishContentLoading && isPublishContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(publishContentErrorContainer?.errorMessage)}
        />
      )}

      {!isPublishContentLoading && isPublishContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(publishContentResponse?.message)}
        />
      )}

      {!isUpadteContentSettingsLoading && isUpadteContentSettingsSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(updateContentSettingsResponse?.message)}
        />
      )}

      {isNewQuestionModalOpen && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }}
        >
          <AddNewQuestions
            handleClose={handleCloseNewQuestionModal}
            handleSubmit={handleAddQuestion}
            handleUpdate={handleUpdateQuestions}
            data={editQuestionData}
            contentId={getEffectiveContentId()}
          />
        </div>
      )}

      {!isSaveFlashCardLoading && isSaveFlashCardSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(flashCardResponse?.message)}
        />
      )}

      {!isSaveFlashCardLoading && isSaveFlashCardFailed && (
        <SnackBarBox
          type="error"
          message={handleError(flashCardErrorContainer?.errorMessage)}
        />
      )}

      {!isDeleteQuestionLoading && isDeleteQuestionFailed && (
        <SnackBarBox
          type="error"
          message={handleError(deleteQuestionErrorContainer?.errorMessage)}
        />
      )}

      <ConfirmBox
        isOpen={isDeleteModalOpen}
        title="Delete question!"
        subtitle="Are you sure you want to delete question."
        handleClose={handleCloseDeleteModal}
        handleSubmit={handleDeleteQuestion}
      />
    </>
  );
};

export default AddNewFlashCard;
